import type EnType from '../en-US/commonParameter';

export default {
  'commonParameter.title.addParameter': 'パラメータを追加',
  'commonParameter.title.name': '名前',
  'commonParameter.title.nameNotNull.message': '名前は必須です。',
  'commonParameter.placeHolder.chooseType': 'データ型を選択',
} satisfies typeof EnType;
